
































































































































































































































































































































































































  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import appconst from '@/lib/appconst';
  import SeverUrl from "@/lib/url";
  import letterInfo from "@/store/entities/jm/hzbletter";
  import elementResizeDetector from "element-resize-detector";
  @Component({
    components:{}
  })
  export default class HZBLetterDetails extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:"0"}) letterid:string;
    @Prop({type:Number,default:0}) sendway:number;
    loadingInstance:boolean=false;
    finding:boolean=false;
    loading:boolean=false;
    modalWidth=window.innerWidth * 0.7;
    currentModel:letterInfo = new letterInfo();
    downloading:boolean=false;
    title:string ="银行函证";
    currentStatus:number=0;
    statusBtn:number=0;
    activeNames=[];
    
    isalert:boolean=false;
    isfile:boolean=false;
    isback:boolean=false;
    headerConfig={Authorization: "Bearer " + window.abp.auth.getToken()};
    postAction=SeverUrl+"api/services/app/hzbletter/UpLoadHzbLetterFile";
    paraData={hzId:'0',pId:'0',flagType:'1'};
    beforeUpload(file) {
      this.paraData.hzId = this.letterid; 
      this.paraData.flagType="1";
    }
    beforeAlert(file) {
      this.paraData.hzId = this.letterid; 
      this.paraData.flagType="2";
    }
    beforeBack(file) {
      this.paraData.hzId = this.letterid; 
      this.paraData.flagType="3";
    }
    onChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100;
       if (!isLt2M) {
         this.$message.error('上传文件不能超过100M');
         fileList.pop();
       }
       this.currentModel.inFileName = fileList;
      }
    onRemove (file, fileList) {
      this.currentModel.inFileName = fileList;
    }
    onSuccess(response,file,fileList){
      var result=response.result;
      if(result.status){
        this.getDetail();
         this.$emit('save-success');
      }
      else{
        this.$alert(response.message,'提示',{type:'info'});
      }
    }
    formatList (num) {
        return Util.format.hzbFormat(num);
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       else{
        if(this.currentModel.projectAuth=='0')
         return true;
       }
       return false;
    }
    cellClass({row,column,rowIndex,columnIndex}){
        if(columnIndex === 2||columnIndex === 3){
          if(columnIndex===2&&rowIndex===2){
            return 'padding: 6px;background:#f5f5f5';
          }
          return 'padding: 6px;background:AliceBlue;font-weight:bold';
        }
        else{
          return 'padding: 6px';
        }
    }
    logClass({row,column,rowIndex,columnIndex}){
        return 'padding: 6px';
    }
    saveRules={
       postNumber:[{required:true,message: '快递单号不能为空',trigger: 'blur'}]
    }
  visibleChange(value) {
      if (!value) {
        this.activeNames=[];
        this.statusBtn=0;
        (this.$refs["bletterDetail"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        this.getDetail();
      }
   }
    close(){
      (this.$refs["bletterDetail"] as any).resetFields();
      this.$emit('input',false);
    }
    async getDetail(){
      this.loadingInstance=true;
       let currid=this.$store.state.jobdo.currjob;
       var response=await this.$store.dispatch({
           type:'hzbletter/getdetail',
           data:{Id:currid,LetterId:this.letterid}
       });
       if(response.length>0){
          let sendway="电子函证";
          if(this.sendway==1){
            sendway="纸质函证";
          }
          this.currentModel=Util.extend(true,{},response[0]);
          this.title=this.currentModel.aName+'>银行函证>'+this.currentModel.custName+'>'+sendway+this.currentModel.hzSn;
          if(this.sendway==1){
            this.saveRules.postNumber[0].required=true;
          }else{
            this.saveRules.postNumber[0].required=false;
          }
          this.statusBtn=Number(this.currentModel.status);
          if(this.sendway==0){
            if(Number(this.currentModel.status)>4){
              this.currentStatus=4;

            }else{
              this.currentStatus=Number(this.currentModel.status)-1;
            }
          }else{
            switch(Number(this.currentModel.status)){
                case 1:
                    this.currentStatus=0;
                    break;
                case 2:
                case 3:
                  this.currentStatus=1;
                  break;
                case 4:
                  this.currentStatus=2;
                  break;
                case 5:
                case 6:
                    this.currentStatus=3;
                    break;
              }
          }
          this.activeNames=this.statusBtn>1?['2']:['1'];
          this.isfile=false;this.isalert=false;this.isback=false;
          if(this.currentModel.inFileName != null && this.currentModel.inFileName.length>0){
              this.currentModel.inFileName.forEach(file=>{
                if(file.inType=='0'||file.inType=='1'){
                  this.isfile=true;
                }
                if(file.inType=='2'){
                  this.isalert=true;
                }
                if(file.inType=='3'){
                  this.isback=true;
                }
              })
          }
          if(this.currentModel.backNotes!=""){
            this.isback=true
          }
      } 
      this.loadingInstance=false;
   }
   async DownOutFile(row:any){
        this.downloading=true;
        await this.$store.dispatch({
            type:'hzbletter/downOutFile',
            data:{HzId:row.hzId,id:row.id,filename:row.name}
        });
        this.downloading=false;
    }
   async DownInFile(row:any){
        this.downloading=true;
        await this.$store.dispatch({
            type:'hzbletter/downInFile',
            data:{HzId:row.hzId,id:row.id,filename:row.name}
        });
        this.downloading=false;
    }
    handleFileRemove(file) {
      if(!this.jobauth){
       this.$alert('无法操作，当前项目处于锁定状态。','提示',{type:'info'});
       return;
    }
    let fileid=file.id;
    let filename=file.name;
    let fileletterid=file.hzId;
    this.$Modal.confirm({
             title:'提示',
             content:'确定要删除该【'+filename+'】文件吗？',
             okText:'确定',
             cancelText:'取消',
             onOk:async()=>{
                 if(fileid!="0"){
                     let response=await this.$store.dispatch({
                         type:'hzbletter/delreply',
                         data:{Id:fileid,HzId:fileletterid}
                     });
                     if(response.success){
                         this.$message({
                             type: 'info',
                             message: '已删除'
                         });
                         await this.getDetail();
                         this.$emit('save-success');
                     }
                     else{
                         this.$message({
                             type: 'info',
                             message: response.message
                         });
                     }
                 }
             }
     }) 
   }
   async back(){
    this.isback=true;
   }
   async cancel(){
      this.$confirm("确定要撤销吗？", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
          //
          this.loading=true;
            let response=await this.$store.dispatch({
                type:'hzbletter/cancelbletter',
                data:{HzId:this.letterid,SendWay:this.sendway}
            });
            if(response.success){
                this.$message({
                message: '已撤销',
                type: 'success'
                });
                this.loading=false;
                (this.$refs.bletterDetail as any).resetFields();
                this.$emit('input',false);
                this.$emit('save-success');
            }
            else{
                this.$alert(response.message,'提示',{type:'info'});
                this.loading=false;
            }
          //
          
      })
      .catch(() => {});        
   }
   async send(){
         (this.$refs.bletterDetail as any).validate(async (valid:boolean)=>{
            if(valid){
              var msgcontent="确定发送该函证吗？";
              this.$confirm(msgcontent, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(async() => {
                      //
                      this.loading=true;
                        let response=await this.$store.dispatch({
                            type:'hzbletter/sendbletter',
                            data:{HzId:this.letterid,SendWay:this.sendway,HzFormat:this.currentModel.hzFormat,PostNumber:this.currentModel.postNumber}
                        });
                        if(response.success){
                            this.$message({
                            message: '已发送',
                            type: 'success'
                            });
                            this.loading=false;
                            (this.$refs.bletterDetail as any).resetFields();
                            this.$emit('input',false);
                            this.$emit('save-success');
                        }
                        else{
                            this.$alert(response.message,'提示',{type:'info'});
                            this.loading=false;
                        }
                      //
                      
                  })
                  .catch(() => {});
              
            }
        })        
   }
   async find(){
      this.loading=true;
      let response=await this.$store.dispatch({
          type:'hzbletter/querybletter',
          data:{HzId:this.letterid,SendWay:this.sendway}
      });
      if(response.success){
          this.$message({
          message: '查询已完成',
          type: 'success'
          });
          await this.getDetail();
          this.loading=false;
      }
      else{
          this.$alert(response.message,'提示',{type:'info'});
          this.loading=false;
      }     
   }
   async reset(){
        this.$confirm('确定要重制该函证生成一份新函证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
          this.loadingInstance=true;
          let result=await this.$store.dispatch({
              type:'hzbletter/resetbletter',
              data:{HzId:this.letterid,SendWay:this.sendway,HzFormat:this.currentModel.hzFormat}
          });
          this.loadingInstance=false;
          if(result&&result.success){
            this.$message({
              message: '重制成功',
              type: 'success'
              });
              (this.$refs.bletterDetail as any).resetFields();
              this.$emit('save-success');
              this.$emit('input',false);
          }
          else{
            this.$alert(result.message,'提示',{type:'info'});
          }
      })
      .catch(() => {});
   }
   async save() {
        this.loadingInstance=true;
        let result=await this.$store.dispatch({
            type:'hzbletter/savebnotes',
            data:{HzId:this.letterid,SendWay:this.sendway,ReplyNotes:this.currentModel.replyNotes,AlertNotes:this.currentModel.alertNotes,BackNotes:this.currentModel.backNotes}
        });
        this.loadingInstance=false;
        if(result&&result.success){
            (this.$refs.bletterDetail as any).resetFields();
            this.$emit('save-success');
            this.$emit('input',false);
        }
        else{
          this.$alert(result.message,'提示',{type:'info'});
        }
    }
    async created(){
       
    }
    async mounted(){
       const that = this;
       var modalH=window.innerHeight-188; 
       var erd = elementResizeDetector();
       erd.listenTo(document.querySelectorAll("#bletterdetail .ivu-modal-content"), (element) => {              
        that.$nextTick(() => { 
            let ivumodal=$(".modal-bletter > div.ivu-modal");
            if(ivumodal){
              if(that.currentModel.hzFormat=='2'&&that.sendway==0){
                ivumodal.css('top','45px');
              }
              else if(that.sendway==1){
                ivumodal.css('top','45px');
              }
              else{
                ivumodal.css('top','100px');
              }
            }
            let modalbody=$(".modal-bletter > div.ivu-modal > div.ivu-modal-content > div.ivu-modal-body");
            if(modalbody){
               if(that.currentModel.hzFormat=='2'&&that.sendway==0){
                if(modalH<480){
                  modalbody.css('max-height','480px');
                }
                else{
                  modalbody.css('max-height',modalH+'px');
                }
               }else if(that.sendway==1){
                  if(modalH<480){
                    modalbody.css('max-height','480px');
                  }
                  else{
                    modalbody.css('max-height',modalH+'px');
                  }
               } 
               else{
                  modalbody.css('max-height','480px');
               }
            }
        });
      });
    }
}
  